const Logo =({qfixLogo})=>{
    return (
        <div className='logo-image-container'>
            <img src={qfixLogo} alt="" className='h-full' />
        </div>
    )
}

export default Logo;